module.exports = __webpack_public_path__ + "img/antes_despues_337.074be4e5.png";